import { EntitySearchFilterBar } from 'src/components/EntitySearch';
import { FilterDropdownItem } from 'src/components/Filters';
import { useListingFilters } from 'src/components/MainFilterBar';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import {
  Feature,
  InventorySearchResult,
  ListingQuery,
} from 'src/WebApiController';

export const InventorySearchFilterBar = (props: {
  activeSearchConfig?: InventorySearchResult;
  onSubmitFilter?: (query: ListingQuery) => void;
  selectedFilters?: FilterDropdownItem[];
  setSelectedFilters: (sf: FilterDropdownItem[]) => void;
}) => {
  const hasSearchViewPerformerFilterFeature = useUserHasFeature(
    Feature.SearchViewPerformerFilter
  );

  const hasUnsoldTicketsFilterFeature = useUserHasFeature(
    Feature.UnsoldTicketsFilter
  );

  const { filters } = useListingFilters({
    isHorizontalLayout: true,
    showCatalogFilters: true,
    showVenueFilter: true,
    showPerformerFilter: hasSearchViewPerformerFilterFeature,
    firstRenderOpen: props.activeSearchConfig == null,
  });

  return (
    <EntitySearchFilterBar
      {...props}
      filters={filters}
      mandatoryFiltersToShow={[
        'eventOrMappingIds',
        'eventDates',
        ...(hasUnsoldTicketsFilterFeature
          ? (['hasUnsoldTickets'] as const)
          : []),
      ]}
      filtersToPin={['eventOrMappingIds']}
    />
  );
};
